import {
  POWERBI_REPORTS_DATA,
  POWERBI_ALL_REPORTS_DATA,
  POWERBI_EMBED_URL_DATA,
  POWERBI_REPORT_GET_DATA,
  POWERBI_SET_SELECTED_REPORT,
  POWERBI_SET_PROFILE_VIEW,
  POWERBI_FAVORITES_DATA,
  POWERBI_ADD_FAVORITE,
  POWERBI_REMOVE_FAVORITE,
} from "./Constants";

// ==================== Actions for Reports List ====================

// Load all Power BI reports
const loadPowerBIReportsDataRequest = () => ({
  type: POWERBI_REPORTS_DATA.POWERBI_REPORTS_DATA_LOAD,
});

const setPowerBIReportsDataSuccess = (reports) => ({
  type: POWERBI_REPORTS_DATA.POWERBI_REPORTS_DATA_SUCCESS,
  reports,
});

const setPowerBIReportsDataFail = (error) => ({
  type: POWERBI_REPORTS_DATA.POWERBI_REPORTS_DATA_FAIL,
  error,
});

// ==================== Actions for All Reports (No Filter) ====================

// Load all Power BI reports without filters
const loadPowerBIAllReportsDataRequest = () => ({
  type: POWERBI_ALL_REPORTS_DATA.POWERBI_ALL_REPORTS_DATA_LOAD,
});

const setPowerBIAllReportsDataSuccess = (allReports) => ({
  type: POWERBI_ALL_REPORTS_DATA.POWERBI_ALL_REPORTS_DATA_SUCCESS,
  allReports,
});

const setPowerBIAllReportsDataFail = (error) => ({
  type: POWERBI_ALL_REPORTS_DATA.POWERBI_ALL_REPORTS_DATA_FAIL,
  error,
});

// ==================== Actions for Embed URL ====================

// Load embed URL and token for a report
const loadPowerBIEmbedUrlRequest = (payload) => ({
  type: POWERBI_EMBED_URL_DATA.POWERBI_EMBED_URL_DATA_LOAD,
  payload,
});

const setPowerBIEmbedUrlSuccess = (embedData) => ({
  type: POWERBI_EMBED_URL_DATA.POWERBI_EMBED_URL_DATA_SUCCESS,
  embedData,
});

const setPowerBIEmbedUrlFail = (error) => ({
  type: POWERBI_EMBED_URL_DATA.POWERBI_EMBED_URL_DATA_FAIL,
  error,
});

// ==================== Actions for Single Report Details ====================

// Get specific report by ID
const loadPowerBIReportGetDataRequest = (id) => ({
  type: POWERBI_REPORT_GET_DATA.POWERBI_REPORT_GET_DATA_LOAD,
  id,
});

const setPowerBIReportGetDataSuccess = (report) => ({
  type: POWERBI_REPORT_GET_DATA.POWERBI_REPORT_GET_DATA_SUCCESS,
  report,
});

const setPowerBIReportGetDataFail = (error) => ({
  type: POWERBI_REPORT_GET_DATA.POWERBI_REPORT_GET_DATA_FAIL,
  error,
});

// ==================== Action for Setting Selected Report ====================

// Set currently selected report (for UI state)
const setSelectedReport = (report) => ({
  type: POWERBI_SET_SELECTED_REPORT,
  report,
});

// ==================== Action for Profile View ====================

// Toggle profile view (for UI state)
const setProfileView = (isProfileView) => ({
  type: POWERBI_SET_PROFILE_VIEW,
  isProfileView,
});

// ==================== Actions for Favorite Reports ====================

// Load all favorite reports
const loadPowerBIFavoritesDataRequest = () => ({
  type: POWERBI_FAVORITES_DATA.POWERBI_FAVORITES_DATA_LOAD,
});

const setPowerBIFavoritesDataSuccess = (favorites) => ({
  type: POWERBI_FAVORITES_DATA.POWERBI_FAVORITES_DATA_SUCCESS,
  favorites,
});

const setPowerBIFavoritesDataFail = (error) => ({
  type: POWERBI_FAVORITES_DATA.POWERBI_FAVORITES_DATA_FAIL,
  error,
});

// Add a report to favorites
const loadPowerBIAddFavoriteRequest = (reportId) => ({
  type: POWERBI_ADD_FAVORITE.POWERBI_ADD_FAVORITE_LOAD,
  reportId,
});

const setPowerBIAddFavoriteSuccess = (reportId) => ({
  type: POWERBI_ADD_FAVORITE.POWERBI_ADD_FAVORITE_SUCCESS,
  reportId,
});

const setPowerBIAddFavoriteFail = (error) => ({
  type: POWERBI_ADD_FAVORITE.POWERBI_ADD_FAVORITE_FAIL,
  error,
});

// Remove a report from favorites
const loadPowerBIRemoveFavoriteRequest = (reportId) => ({
  type: POWERBI_REMOVE_FAVORITE.POWERBI_REMOVE_FAVORITE_LOAD,
  reportId,
});

const setPowerBIRemoveFavoriteSuccess = (reportId) => ({
  type: POWERBI_REMOVE_FAVORITE.POWERBI_REMOVE_FAVORITE_SUCCESS,
  reportId,
});

const setPowerBIRemoveFavoriteFail = (error) => ({
  type: POWERBI_REMOVE_FAVORITE.POWERBI_REMOVE_FAVORITE_FAIL,
  error,
});

// ==================== Exports ====================

export {
  loadPowerBIReportsDataRequest,
  setPowerBIReportsDataSuccess,
  setPowerBIReportsDataFail,
  loadPowerBIAllReportsDataRequest,
  setPowerBIAllReportsDataSuccess,
  setPowerBIAllReportsDataFail,
  loadPowerBIEmbedUrlRequest,
  setPowerBIEmbedUrlSuccess,
  setPowerBIEmbedUrlFail,
  loadPowerBIReportGetDataRequest,
  setPowerBIReportGetDataSuccess,
  setPowerBIReportGetDataFail,
  setSelectedReport,
  setProfileView,
  loadPowerBIFavoritesDataRequest,
  setPowerBIFavoritesDataSuccess,
  setPowerBIFavoritesDataFail,
  loadPowerBIAddFavoriteRequest,
  setPowerBIAddFavoriteSuccess,
  setPowerBIAddFavoriteFail,
  loadPowerBIRemoveFavoriteRequest,
  setPowerBIRemoveFavoriteSuccess,
  setPowerBIRemoveFavoriteFail,
};
